export const FORMS_CONFIRMED_ACTION = '[forms action] successfully';
export const FORMS_FAILED_ACTION = '[forms action] not successfully';
export const FORM_CREATE_CONFIRMED_ACTION = '[form create action] successfully';
export const FORM_CREATE_FAILED_ACTION = '[form create action] not successfully';

export const JOBTITLE_CONFIRMED_ACTION = '[job list action] successfully';
export const JOBTITLE_FAILED_ACTION = '[job list action] not successfully';
export const JOBBYID_CONFIRMED_ACTION = '[job by id action] successfully';
export const JOBBYID_FAILED_ACTION = '[job by id action] not successfully';

export const CL_CONFIRMED_ACTION = '[contract location action] successfully';
export const CL_FAILED_ACTION = '[contract location action] not successfully';


export const FOLDER_CONFIRMED_ACTION = '[folder action] successfully';  
export const FOLDER_FAILED_ACTION = '[folder action] not successfully';  
export const OKTA_USER_SEARCH_CONFIRMED_ACTION = '[okta user search action] successfully';  
export const OKTA_USER_SEARCH_FAILED_ACTION = '[okta user search action] not successfully';  
export const UPLOAD_CONFIRMED_ACTION = '[upload action] successfully';
export const UPLOAD_FAILED_ACTION = '[upload action] not successfully';

export const SET_USER_PROFILE = '[set user profile action] successfully';
export const GET_USER_PROFILE = '[get user profile action] successfully';
export const SET_USER_PROFILE_FAILED_ACTION = '[set user profile action] not successfully';
export const GET_USER_PROFILE_FAILED_ACTION = '[get user profile action] not successfully';


export const PROJECT_CODE_CONFIRMED_ACTION = '[project code action] successfully';
export const PROJECT_CODE_FAILED_ACTION = '[project action] not successfully';
export const PROJECT_CODE_ONEMP_ACTION = '[project code on employee action] successfully';
export const PROJECT_CODE_ONEMP_FAILED_ACTION = '[project code on employee action] not successfully';

export const ACCOUNT_CODE_CONFIRMED_ACTION = '[account code action] successfully';
export const ACCOUNT_CODE_FAILED_ACTION = '[account action] not successfully';